export default "__VITE_ASSET__7d41b95a__"